// Convierte URLs de Vimeo (incluyendo URLs de gestion /manage/videos/{id})
// y YouTube en URLs embeddables para iframes.
export function toEmbedUrl(url) {
  if (!url || typeof url !== 'string') return url;
  const trimmed = url.trim();

  // Vimeo: cualquier URL que contenga vimeo.com y termine con un ID numerico.
  // Ejemplos soportados:
  //   https://vimeo.com/1144018608
  //   https://vimeo.com/manage/videos/1144018608
  //   https://vimeo.com/channels/foo/1144018608
  if (/vimeo\.com/i.test(trimmed) && !/player\.vimeo\.com/i.test(trimmed)) {
    const m = trimmed.match(/vimeo\.com\/(?:[^/]+\/)*?(\d+)(?:[/?#]|$)/i);
    if (m) return `https://player.vimeo.com/video/${m[1]}`;
  }

  // YouTube: watch?v= o youtu.be/ -> embed
  const ytWatch = trimmed.match(/youtube\.com\/watch\?(?:.*&)?v=([\w-]+)/i);
  if (ytWatch) return `https://www.youtube.com/embed/${ytWatch[1]}`;
  const ytShort = trimmed.match(/youtu\.be\/([\w-]+)/i);
  if (ytShort) return `https://www.youtube.com/embed/${ytShort[1]}`;

  return trimmed;
}
